
function ConeAdsens() {
  return (
    <div id="foremediaads-c1"></div>

  )
}

export default ConeAdsens
